module.exports = __webpack_public_path__ + "img/3.4545c8f6.png";